import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, ViewEncapsulation } from '@angular/core';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { hoverCardBridgeStyles, hoverCardStyleId } from './hover.card.theme';

export interface HoverCardRow {
  label?: string;
  value: string;
}

/** Content of a dark hover card; the surface is the shared `wb-dark-tooltip`, so this lays out text only. */
@Component({
  selector: 'wb-hover-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="hover-card">
      @if ($title()) {
        <div class="card-title">{{ $title() }}</div>
      }
      <div class="card-rows">
        @for (row of $rows(); track $index) {
          @if (row.label) {
            <span class="card-label">{{ row.label }}</span>
          }
          <span class="card-value" [class.unlabelled]="!row.label">{{ row.value }}</span>
        }
      </div>
    </div>
  `,
  styleUrls: ['./hover.card.component.less'],
})
export class HoverCardComponent {

  private readonly document = inject(DOCUMENT);

  public readonly $title = input('', { alias: 'title' });
  public readonly $rows = input<readonly HoverCardRow[]>([], { alias: 'rows' });

  public constructor() {

    DesignSystem.Mount(this.document, hoverCardStyleId, hoverCardBridgeStyles);
  }
}
